import { GetSelfResponse } from './interfaces/getSelf.interface'
import { nApi } from '../index'

export const getSelf = async (): Promise<GetSelfResponse> => {
  const result = await nApi().get<GetSelfResponse>(`/v2_private/auth/self`)

  return result.data
}
